import React from 'react';
import { UIView } from '../../../utils/styled/styled';
import { Components } from './styled';
import ProjectSideBar from '../../ProjectSideBar';
import ProjectHeaderBar from '../../ProjectHeaderBar';

const ProjectContainer = ({
  children,
  hasBack,
  title,
  secondaryTitle,
}: {
  children?: React.ReactNode;
  hasBack?: boolean | string;
  title?: string;
  secondaryTitle?: string;
}) => {
  return (
    <UIView fullWidth fullScreenHeight displayFlex>
      <ProjectSideBar />
      <Components.RightSideContainer autoHeight displayFlex flexDirection='column'>
        <ProjectHeaderBar title={title} secondaryTitle={secondaryTitle} hasBack={hasBack} />
        <Components.ChildrenWrapper>{children}</Components.ChildrenWrapper>
      </Components.RightSideContainer>
    </UIView>
  );
};

export default ProjectContainer;
